import React, { useState } from "react";
import PaymentSlipView from "./PaymentSlipView";
import { PlanInputSelectDTO } from "../../../models/plan/plan.response";
import { useParams } from "react-router-dom";
import { planSubscriptionService } from "../../../services/planSubscriptionService";
import { useNotification } from "../../toster-notification/NotificationContext";
import Loader from "../../shared/Loader";

interface PaymentBankAccountTabProps {
    plan?: PlanInputSelectDTO;
}

const PaymentBankAccountTab: React.FC<PaymentBankAccountTabProps> = ({ plan }) => {

    const [paymentSlipOpen, setPaymentSlipOpen] = useState(false);
    const { localId } = useParams<{ localId: string }>();

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();


    const handleConfirmPayment = async () => {
        if (!plan?.id) {
            notify("error", "Izaberite paket");
            return;
        }

        if (!localId) {
            notify("error", "Nije pronađena ID lokala");
            return;
        }

        setLoading(true);
        try {
            console.log("Sending payment confirmation with localId:", localId, "and planId:", plan.id);
            const response = await planSubscriptionService.paymentConfirmNotify(plan?.id, localId);

            if (response.success) {
                notify("success", "Uspešno poslato obaveštenje o plaćanju");
            }
        }
        catch (error) {
            notify("error", "Greška prilikom potvrde plaćanja");
        }
        finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader />;
    }


    return (
        <>
            {paymentSlipOpen &&
                <PaymentSlipView
                    onClose={() => setPaymentSlipOpen(false)}
                    plan={plan}
                />}

            <div className="modal-box-div">
                <div className="modal-box-header-div">
                    <div className="modal-box-header-title">Podaci za uplatu</div>
                    <div className="description-text">
                        Izvršite uplatu na sledeći račun<br />
                    </div>
                </div>
                <div className="div-block-27">
                    <div>
                        <div className="description-text">Primalac</div>
                        <div className="input-div">
                            <div>Digitalni Meni d.o.o.</div>
                        </div>
                    </div>
                    <div>
                        <div className="description-text">
                            Broj računa<br />
                        </div>
                        <div className="input-div">
                            <div>170-10687417000-04</div>
                        </div>
                    </div>
                    <div>
                        <div className="description-text">Banka</div>
                        <div className="input-div">
                            <div>UniCredit</div>
                        </div>
                    </div>
                    <div>
                        <div className="description-text">
                            Poziv na broj<br />
                        </div>
                        <div className="input-div">
                            <div>97</div>
                        </div>
                    </div>
                    <div>
                        <div className="description-text">Svrha uplate</div>
                        <div className="input-div">
                            <div>DM - &quot;ime lokala &quot; - &quot;mesec/godina &quot; - &quot;{plan?.name || "*Naziv plana*"}&quot;</div>
                        </div>
                    </div>
                    <div>
                        <div className="description-text">Iznos</div>
                        <div className="input-div">
                            <div>{plan?.price || "*Cena plana*"} RSD</div>
                        </div>
                    </div>
                    <div className="payment-slip-open-button">
                        <div className="button-primary" onClick={() => setPaymentSlipOpen(true)}>
                            <div>Pogledaj uplatnicu</div>
                        </div>
                        <div className="button-primary green-bg" onClick={() => handleConfirmPayment()}>
                            <div>Potvrdite uplatu</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

};

export default PaymentBankAccountTab;